import React from 'react'
import IntradayRobust from './IntradayRobust'

const Intraday = () => {
  return <IntradayRobust />
}

export default Intraday 